import {Box, BoxProps, HStack, UnorderedList, ListItem, ListItemProps, Heading, Image} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';

type Props = BoxProps & {
  examples: string[]
};

export default function StepExamples({examples, ...props}: Props) {
  return (
    <Box {...props}>
      <Heading as="h3" h={['1.625rem', '1.625rem', "2.25rem"]} textAlign="center">
        <Image src={`${IMAGE_PREFIX}txt-graph-01.png`} alt="例えば…" display="inline" maxH="full" />
      </Heading>
      <HStack mt={[6, 6, 7]} spacing={`${25.4/16}rem`} justify="center" align="flex-start" mx="auto">
        <Box flexBasis={[`${40/16}rem`, `${40/16}rem`, `${54/16}rem`]} flexShrink={[0, 0, 'auto']}>
          <Image src={`${IMAGE_PREFIX}img-graph-04.png`} alt="" />
        </Box>
        <UnorderedList listStyleType="none" mt="7" fontSize="lg" lineHeight="none">
          {examples.map((example, index) =>
            <EstateExample key={example} mt={index === 0 ? 0 : 6}>{example}</EstateExample>)}
        </UnorderedList>
      </HStack>
    </Box>
  );
}

function EstateExample(props: ListItemProps) {
  return (
    <ListItem
      lineHeight={['1.5', '1.5', '1']}
      {...props}
      _before={{
        content: '""',
        display: 'inline-block',
        fontSize: "md",
        mr: [1, 1, 4],
        w: '4',
        h: '4',
        transform: 'translateY(1px)',
        borderRadius: '50%',
        bgColor: 'blue.500'
      }}
    />
  );
}
